import React from 'react'
import { useFormContext } from 'react-hook-form'
import './BusinessLicenseField.scss'
import BasicField from '../BasicField/BasicField'
import '../BasicField/BasicField.scss'
import GraphemeSplitter from 'grapheme-splitter'
import { XMarkIcon } from '@heroicons/react/24/solid'
import { uploadS3 } from '../../../../../utils'

const BusinessLicenseField = ({ name, label, optional, placeholder, validation }) => {
	const {
		register,
		setValue,
		setError,
		clearErrors,
		formState: { errors },
	} = useFormContext()
	const [fileName, setFileName] = React.useState('')
	const fileInputRef = React.useRef(null) //입력된 파일의 ref
	//파일 업로드 버튼 클릭시 파일 입력 요소에 대해 클릭하는 이벤트 발생

	const handleButtonClick = () => {
		fileInputRef.current.click()
	}

	function truncateFileName(filename, maxLength = 20) {
		const ext = filename.slice(filename.lastIndexOf('.'))
		const base = filename.slice(0, filename.length - ext.length)
		const splitter = new GraphemeSplitter()
		const chars = splitter.splitGraphemes(base)
		if (chars.length > 18) {
			const truncated = chars.slice(0, maxLength - 3).join('')
			return `${truncated}..${ext}`
		}

		return filename
	}

	const handleFileUpload = async (e) => {
		const file = e.target.files?.[0]
		if (!file) return

		const allowedTypes = ['application/pdf', 'image/jpg', 'image/png']
		const isTooLarge = file.size > 5 * 1024 * 1024
		const isInvalidType = !allowedTypes.includes(file.type)

		if (isTooLarge || isInvalidType) {
			setError(name, {
				type: 'manual',
				message: 'PDF, JPG, PNG 형식 / 5MB 이하만 가능해요.',
			})
			setValue(name, null)
			e.target.value = ''
			setFileName('')
			return
		}

		clearErrors(name)
		setFileName(file.name)

		try {
			// 고유한 임시 ID 생성 (UUID v4 스타일)
			const tempUserId = 'temp_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9)
			const businessURL = await uploadS3(tempUserId, 'business', file)
			console.log('업로드된 S3 URL:', businessURL)
			setValue(name, businessURL)
		} catch (uploadError) {
			console.error('S3 업로드 실패:', uploadError)
			setError(name, {
				type: 'manual',
				message: '파일 업로드에 실패했습니다. 다시 시도해주세요.',
			})
			setValue(name, null)
			e.target.value = ''
			setFileName('')
		}
	}
	return (
		<BasicField
			name={name}
			label={label}
			placeholder={placeholder}
			optional={optional}
			validation={validation}
			useChildrenWrapper={false}>
			{/*버튼 스타일 컴포넌트*/}
			<div>
				<input
					type="file"
					//<input type="file"에 두가지 ref를 동시에 적용하기 위한 테크닉
					ref={(el) => {
						fileInputRef.current = el
						register(name, validation).ref(el)
					}}
					onChange={handleFileUpload}
					style={{ display: 'none' }}
				/>
				{fileName ? (
					<div className={`fillin-box ${errors[name] ? 'error' : ''}`}>
						<span className="file-name-display">{truncateFileName(fileName)}</span>
						<button
							type="button"
							onClick={() => {
								setFileName('')
								setValue(name, null)
								fileInputRef.current.value = ''
							}}
							style={{ all: 'unset', margin: '8px' }}>
							<XMarkIcon
								className="h-6 w-6 text-gray-500"
								style={{ width: '12px', height: '12px' }}
							/>
						</button>
						<button
							type="button"
							className="btn-with-input"
							onClick={handleButtonClick}>
							파일 업로드
						</button>
					</div>
				) : (
					<div
						className={`fillin-box ${errors[name] ? 'error' : ''} `}
						style={{ borderColor: '#E4E4E4' }}>
						<span className="upload-placeholder">파일을 업로드해주세요</span>
						<button
							type="button"
							className="btn-with-input"
							onClick={handleButtonClick}>
							파일 업로드
						</button>
					</div>
				)}
				{/*실제 파일 입력 요소*/}
			</div>
		</BasicField>
	)
}

export default BusinessLicenseField
